import { Text } from '@mnd-frontend/ui/publish/components';
import type { FC } from 'react';
import { Trans } from 'react-i18next';
import styled from 'styled-components';

const Flex = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

type Props = {
  currentStep: number;
  heading: string;
};

const OnboardingCardHeader: FC<Props> = ({ currentStep, heading }) => {
  return (
    <div>
      <Flex>
        <Text as="span" variant="labelSmall" color="GREY_800">
          <Trans
            i18nKey="onboarding-stepper"
            values={{
              currentStep,
              total: 4,
            }}
          />
        </Text>
      </Flex>
      <Text as="h2" variant="headlineMedium">
        {heading}
      </Text>
    </div>
  );
};

export default OnboardingCardHeader;
